import { matchPath } from 'react-router-dom';
import { datosTeatro } from 'content/site';

const rutasInformativasWhatsApp = [
  '/',
  '/inicio',
  '/quienes-somos',
  '/galeria',
  '/galeria/:id',
  '/galeria-talleres',
  '/alquiler-de-salas',
  '/hacete-socio',
  '/contacto',
  '/politicas',
  '/espectaculos/:id',
  '/taller/:id',
];

export const esRutaInformativaWhatsApp = (pathname: string) =>
  rutasInformativasWhatsApp.some(path => matchPath({ path, end: true }, pathname));

export const crearUrlWhatsApp = () => {
  const { numeroWaMe, mensajeAutomatico } = datosTeatro.whatsapp;

  return `https://wa.me/${numeroWaMe}?text=${encodeURIComponent(mensajeAutomatico)}`;
};
